import { Dictionary } from '../interfaces/dictionary.interface';
import { MobizOrganizationRole } from '../other/mobiz-organization-role.type';
import { SerializableObject } from './serializable-object';

/** The OrganizationMembership domain object. */
export class OrganizationMembership extends SerializableObject {
  id: string;
  createdUtc: string;
  modifiedUtc: string;
  createdBy: string;
  modifiedBy: string;
  organizationId: string;
  organization: any;
  userId: string;
  user: any;
  createdByUser: any;
  membershipRole: MobizOrganizationRole;
  membershipStatus: string;
  membershipScopedRoles: Dictionary<string>;

  erpAuthenticated: boolean;
  // TODO: Fix spelling error for authentication.
  erpAuthicationExpiration: string;
  erpEmployeeId: string;
  erpUsername: string;
  erpManualAuth: boolean;
}
